<template>
  <section class="viewsrhqyBasicManage_companyC3Config p-4 space-y-4">
    <viewTitle title="业务管理 / 基础数据管理 / C3配置" :showReturn="false" />
    <div class="space-x-4">
      <el-button v-has="['c-base-mp-c3-config-save']" type="primary" @click="onAdd">新增</el-button>
      <el-button @click="loadData">刷新</el-button>
    </div>
    <c-table :isIndex="false" :data="dataSource" :columns="columns" :showPagination="false">
      <template slot="action" slot-scope="scope">
        <el-row type="flex" justify="space-around" align="middle">
          <c-link v-has="['c-base-mp-c3-config-save']" @click="onEdit(scope.row)" label="修改"></c-link>
          <c-link v-has="['c-base-mp-c3-config-send']" @click="onSend(scope.row)" label="发送"></c-link>
          <c-link v-has="['c-base-mp-c3-config-delete']" @click="onDelete(scope.row)" label="删除" type="danger"></c-link>
        </el-row>
      </template>
    </c-table>

    <el-dialog :visible.sync="dialogVisible" width="640px" :close-on-click-modal="false" title="C3配置">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="称台编号" prop="weighbridge_code">
          <el-input v-model="form.weighbridge_code" clearable></el-input>
        </el-form-item>
        <el-form-item label="MAC地址">
          <el-input v-model="form.mac_address" clearable></el-input>
        </el-form-item>
        <el-form-item label="开门时长">
          <el-input v-model="form.time" clearable></el-input>
        </el-form-item>
        <el-form-item label="门号">
          <el-input v-model="form.door_code" clearable></el-input>
        </el-form-item>
        <el-form-item label="控制器IP" prop="cu_ip">
          <el-input v-model="form.cu_ip" clearable></el-input>
        </el-form-item>
        <el-form-item label="控制器端口" prop="cu_port">
          <el-input v-model="form.cu_port" clearable></el-input>
        </el-form-item>
        <el-form-item label="发送指令" prop="auth_directive">
          <el-input type="textarea" :rows="3" v-model="form.auth_directive"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :rows="3" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button v-has="['c-base-mp-c3-config-save']" type="primary" @click="onSave">保存</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      dataSource: [],
      dialogVisible: false,
      form: this.getEmptyForm(),
      columns: [
        { label: "名称", prop: "name" },
        { label: "称台编号", prop: "weighbridge_code" },
        { label: "控制器IP", prop: "cu_ip" },
        { label: "控制器端口", prop: "cu_port" },
        { label: "门号", prop: "door_code" },
        { label: "备注", prop: "remark" },
        { label: "最后修改人", prop: "update_by_name", width: 120 },
        {
          label: "最后修改时间",
          prop: "update_time",
          width: 160,
          // 关键步骤：通过公共表格 formatter 统一格式化时间戳，0/1 这类无效值显示为未修改。
          formatter: row => (row.update_time > 1 ? moment(row.update_time * 1000).format("YYYY-MM-DD HH:mm:ss") : "-")
        },
        { label: "操作", prop: "action", width: 180 }
      ],
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        weighbridge_code: [{ required: true, message: "请输入称台编号", trigger: "blur" }],
        cu_ip: [{ required: true, message: "请输入控制器IP", trigger: "blur" }],
        cu_port: [{ required: true, message: "请输入控制器端口", trigger: "blur" }],
        auth_directive: [{ required: true, message: "请输入发送指令", trigger: "blur" }]
      }
    };
  },
  methods: {
    // 获取空白表单，避免弹窗状态互相污染。
    getEmptyForm() {
      return {
        id: "",
        name: "",
        remark: "",
        weighbridge_code: "",
        mac_address: "",
        time: 0,
        door_code: "",
        cu_ip: "",
        cu_port: "",
        auth_directive: ""
      };
    },
    // 查询当前基地 C3 配置列表。
    async loadData() {
      try {
        const dataObj = await this.$common.http({
          url: "/api/queue/admin/query_company_c3_list"
        });
        // 关键步骤：逐层取数据，确保结构正确。
        const list = (dataObj.data && dataObj.data.data) || [];
        this.dataSource = list.map(item => ({
          ...this.getEmptyForm(),
          ...item
        }));
      } catch (error) {}
    },
    // 打开新增弹窗。
    onAdd() {
      this.form = this.getEmptyForm();
      this.dialogVisible = true;
    },
    // 打开编辑弹窗并回填当前记录。
    onEdit(row) {
      this.form = {
        ...this.getEmptyForm(),
        ...row
      };
      this.dialogVisible = true;
    },
    // 保存 C3 配置。
    onSave() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return;
        }
        try {
          await this.$common.http({
            url: "/api/queue/admin/save_company_c3",
            data: this.form
          });
          this.$message.success("保存成功！");
          this.dialogVisible = false;
          this.loadData();
        } catch (error) {}
      });
    },
    // 删除当前 C3 配置。
    onDelete(row) {
      this.$confirm("确认删除该C3配置?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/admin/delete_company_c3",
            data: { id: row.id }
          });
          this.$message.success("删除成功！");
          this.loadData();
        } catch (error) {}
      });
    },
    // 测试发送当前行配置指令。
    async onSend(row) {
      try {
        const dataObj = await this.$common.http({
          url: "/api/queue/admin/send_company_c3_directive",
          data: { id: row.id }
        });
        const result = dataObj.data.data || {};
        this.$alert(result.response || result.message || "发送完成", "发送结果", {
          confirmButtonText: "确定"
        });
      } catch (error) {}
    }
  },
  created() {
    this.loadData();
  }
};
</script>
